export const PreReserveUrl = {
  // PreReserve
  // get by nationalCode
  getAll: '/PreReserve/PreReserveQuery/GetAllPreReserves',
  // get by nationalCode
  getByNationalCode: '/PreReserve/PreReserveQuery/GetPreReserveByNationalCode',
  // get by id
  getById: '/PreReserve/PreReserveQuery/GetPreReservePilgrimsById',
  // Cancle PreReserve
  CanclePreReserve: '/PreReserve/PreReserveCommand/Cancel',
  // Update Tour Kind Type
  UpdateTourKindType: '/PreReserve/PreReserveCommand/UpdateTransportationTypeCommand',
  // Delete PreReserve
  DeletePreReserve: '/PreReserve/PreReserveCommand/Delete',
  // Dispatch PreReserve
  DispatchPreReserve: '/PreReserve/PreReserveCommand/Dispatch',
  // Update PreReserve Province
  UpdatePreReserveProvince: '/PreReserve/PreReserveCommand/UpdatePreReserveProvince',
}
